import React, {useState} from 'react';
import {Modal, Button, Icon, Table, Grid, Input, Loader} from 'semantic-ui-react';
import {Actions} from '../../../../../common/actions';
import {useDispatch, useSelector} from 'react-redux';
import AccessoriesListTable from './accessoriesListTable';
import {getColumns} from './accessoriesListColumns';

import '../../styles.scss';

const {
  fetchAccessoriesList,
  cleanAccessoriesList,
} = Actions;

const AccessoriesModal = ({handleComboAccessories, isSelected, disabled}) => {
  const [modalOpened, setModalOpened] = useState(false);
  const loading = useSelector((state) => state.accessoriesList.loading);
  const accessoriesList = useSelector((state) => state.accessoriesList.list);
  const [accessoriesFilter, setAccessoriesFilter] = useState({'code': '', 'description': ''});
  const [columns] = useState(getColumns());
  const dispatch = useDispatch();

  const openComboAccessoriesModal = (e) => {
    e.preventDefault();
    setModalOpened(true);
  };

  const closeComboAccesorioesModal = (e) => {
    e.preventDefault();
    dispatch(cleanAccessoriesList());
    setAccessoriesFilter({'code': '', 'description': ''});
    setModalOpened(false);
  };

  const handleAccessoriesSearch = (e) => {
    e.preventDefault();
    dispatch(fetchAccessoriesList(accessoriesFilter));
  };

  const handleFiltersChange = (e, input) => {
    e.preventDefault();
    setAccessoriesFilter({...accessoriesFilter, [input.id]: input.value});
  };

  const renderLoader = () => {
    return (
      <Table striped className='toyota-grid'>
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' content='Ejecutando' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  };

  return (
    <Modal
      trigger={
        <Button primary content='Añadir accesorios' className='ico-center' disabled={disabled}
          icon={<Icon className='toolbox' size='big'/>} />
      }
      open={modalOpened}
      onOpen={(e) => openComboAccessoriesModal(e)}
      onClose={(e) => closeComboAccesorioesModal(e)}
      size='large'
      closeOnEscape={true}
      closeOnDimmerClick={true}
      header={
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>Búsqueda de accesorios</h2>
          <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => closeComboAccesorioesModal(e)} />
        </div>
      }
      content={
        <div className='content'>
          <Grid>
            <Grid.Row>
              <Grid.Column width={4}>
                <Input id='code' label='Código' value={accessoriesFilter.code}
                  onChange={(e, input) => handleFiltersChange(e, input)} />
              </Grid.Column>
              <Grid.Column width={9}>
                <Input id='description' label='Descripción' fluid value={accessoriesFilter.description}
                  onChange={(e, input) => handleFiltersChange(e, input)} />
              </Grid.Column>
              <Grid.Column width={3} textAlign='right'>
                <Button primary icon={<Icon name='search' size='big' />}
                  size='tiny' className='ico-center' content='Buscar'
                  onClick={(e) => handleAccessoriesSearch(e)} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          {
            loading ? renderLoader() :
              <AccessoriesListTable tableColumns={columns} tableData={accessoriesList} disabled={disabled}
                handleComboAccessories={handleComboAccessories.bind(this)} isSelected={isSelected.bind(this)} />}
        </div>
      }
    />
  );
};

export default AccessoriesModal;
